import { useState, memo } from "react";
import { ListGroup, Row, Col } from "react-bootstrap";

import PostComponent from "./PostComponent";
import InputComponent from "./InputComponent";
import CustomLoadingOverlay from "./CustomLoadingOverlay";

import styled from "styled-components";

import SetState from "../typings/SetState";
import Channel from "../typings/Channel";

const PostsCol = styled(Col)`
  margin-left: 1rem;
  @media (max-width: 767px) {
    margin-left: 0;
    margin-top: 1rem;
    margin-bottom: 1rem;
  } ;
`;

const PostsWrapper = styled.div`
  height: 76vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: 5px;
  justify-content: flex-end;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  background-color: white;

  @media (min-height: 820px) {
    height: 80vh;
  }
`;

const Header = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  text-align: center;
  background-color: #222c4a;
  color: white;
  font-weight: 500;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
`;

const PostsList = styled(ListGroup)`
  flex-direction: column-reverse;
  overflow-y: auto;
  margin-top: 46px;
`;

type PostGroupProps = {
  channelName: string;
  posts: Channel["messages"];
  onSendMessageHandler: (message: string, tags?: string[]) => void;
  setMultiMessageModal: SetState<boolean>;
  loading: boolean;
};

const PostGroup = ({
  channelName,
  posts,
  onSendMessageHandler,
  setMultiMessageModal,
  loading,
}: PostGroupProps) => {
  const [message, setMessage] = useState("");

  const onSubmitHandler = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onSendMessageHandler(message);
    setMessage("");
  };

  let postComponents = posts.map((post) => (
    <PostComponent key={post._id} post={post} />
  ));
  return (
    <PostsCol>
      <CustomLoadingOverlay active={loading}>
        <PostsWrapper>
          <Header>{channelName ? channelName : "Select a channel"}</Header>
          <PostsList>{postComponents}</PostsList>
        </PostsWrapper>
      </CustomLoadingOverlay>
      <Row className="mt-3">
        <InputComponent
          size="lg"
          setValue={setMessage}
          disabled={channelName ? false : true}
          onSubmitHandler={onSubmitHandler}
          value={message}
          setMultiMessageModal={setMultiMessageModal}
        />
      </Row>
    </PostsCol>
  );
};

export default memo(PostGroup);
